<template>
  <v-container>
    <v-row>
      <v-col>
        <h2>Habilitar temas no município</h2>
        <h5>
          <span style="font-weight: normal">
            Os temas habilitados aparecerão no gráfico de evolução do município.
          </span>
        </h5>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <combobox-unidade-regional
          :filter="permissao"
        ></combobox-unidade-regional>
      </v-col>
      <v-col>
        <municipio-combo
          :filter="permissao"
          @allMunicipio="addMunicipio"
        ></municipio-combo>
      </v-col>

      <v-col v-if="permissao.municipio.length">
        <TemaMultipleCombobox
          :filter="permissao"
          @onChange="changePermission()"
        ></TemaMultipleCombobox>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="addPermission">
          Adicionar Temas
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="usuario.permissoes"
          class="elevation-1"
          ref="table"
          :items-per-page="5"
          :search="search"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': 'Items por página',
          }"
        >
          <template v-slot:header.selection="{ header }">
            <v-checkbox
              v-model="allSelected"
              color="primary"
              @change="
                usuario.permissoes = usuario.permissoes.map((item) => {
                  return {
                    ...item,
                    selection: !!allSelected,
                  };
                })
              "
            >
            </v-checkbox>
          </template>

          <template slot="no-data">
            <span> Nenhuma permissão encontrada </span>
          </template>

          <template v-slot:item.selection="{ item, index }">
            <v-checkbox
              color="primary"
              v-model="item.selection"
              @change="
                usuario.permissoes = usuario.permissoes.map((item, i) => {
                  if (index === i) {
                    item.selection = $event;
                  }
                  return item;
                })
              "
            >
            </v-checkbox>
          </template>

          <template v-slot:item.tema="{ item }">
            <TemaMultipleCombobox
              :filter="item"
              :temaId="item.temaId"
            ></TemaMultipleCombobox>
          </template>

          <template v-slot:item.actions="{ item, index }">
            <v-btn
              outlined
              color="error"
              class="mr-3"
              @click="removeOnePermission({ item })"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>

          <template v-slot:top>
            <div style="padding: 10px">
              <h6>Filtros</h6>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquise..."
              ></v-text-field>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="insertUser">
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { AppGroupCombobox, AppPermissionCombobox } from "@/modules/user";
import { AppAxisByProjectCombobox } from "@/modules/axis";
import { AppCityComboboxSingle } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import MunicipioCombo from "@/modules/user/components/MunicipioCombo.vue";
import { axisAPI } from "@/modules/axis";
import ComboboxUnidadeRegional from "@/modules/ur/components/Combobox.vue";
import TemaMultipleCombobox from "../../tema/components/TemaMultipleCombobox.vue";
import { municipioTemasHabilitadosAPI } from "@/apis";
export default {
  components: {
    AppGroupCombobox,
    AppPermissionCombobox,
    AppCityComboboxSingle,
    AppAxisByProjectCombobox,
    MunicipioCombo,
    ComboboxUnidadeRegional,
    TemaMultipleCombobox,
  },
  data() {
    return {
      usuario: {
        habilitado: true,
        permissoes: [],
      },
      user: JSON.parse(localStorage.getItem("user")),
      search: "",
      headers: [
        { text: "", value: "selection", sortable: false, width: "5%" },
        { text: "Município", value: "municipio.nome" },
        { text: "Temas", value: "tema", width: "30%", sortable: false },
        { text: "Ações", value: "actions", width: "10%", sortable: false },
      ],
      userDisabled: null,
      allSelected: false,
      groupsHierarquia: [],
      permissao: {
        municipioId: null,
        municipio: [],
        permissaoId: null,
        permissao: {},
        eixoId: null,
        tema: [],
      },
      listaEixos: [],
      emailRules: [async (v) => this.verifyEmail(v)],
      maisdados: false,
      desabilitarEnvio: false,
      emailErrors: null,
      allMunicipio: [],
      temasHabilitados: [],
      temasHabilitadosHash: [],
      field: "nome",
    };
  },
  mounted() {
    if (this.isGov) {
      this.headers = [
        { text: "", value: "selection", sortable: false, width: "5%" },
        { text: "Projeto", value: "municipio.nome" },
        { text: "Temas", value: "tema", width: "30%", sortable: false },
        { text: "Ações", value: "actions", width: "10%", sortable: false },
      ];
    }

    this.getMunicipioTemasHabilitados();
  },
  watch: {
    "permissao.id_unidade_regional"(val) {
      if (val) {
        this.permissao.municipio = this.allMunicipio.filter(
          (item) => item.id_unidade_regional == val
        );
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    addMunicipio(municipio) {
      this.allMunicipio = municipio;
      if (municipio && municipio.length > 0) {
        this.usuario.permissoes = municipio.map((item) => {
          return {
            municipioId: item.municipioId,
            temaId: this.temasHabilitadosHash[item.municipioId]
              ? this.temasHabilitadosHash[item.municipioId].temaId
              : [],
            municipio: item,
            tema: this.temasHabilitadosHash[item.municipioId]
              ? this.temasHabilitadosHash[item.municipioId].map((item) => ({
                  temaId: item.temaId,
                }))
              : [],
          };
        });
      }
    },
    getChangedMunicipios() {
      const changedItems = [];

      // Percorre todos os municípios das permissões atuais
      this.usuario.permissoes.forEach((permissao) => {
        const municipioId = permissao.municipioId;
        const temasAtuais = permissao.tema.map((t) => t.temaId).sort();

        // Pega os temas originais do município (do this.temasHabilitados)
        const temasOriginais = this.temasHabilitadosHash[municipioId]
          ? this.temasHabilitadosHash[municipioId].map((t) => t.temaId).sort()
          : [];

        // Compara se houve mudança
        const temasOriginaisString = temasOriginais.join(",");
        const temasAtuaisString = temasAtuais.join(",");

        if (temasOriginaisString !== temasAtuaisString) {
          // Adiciona todos os temas atuais do município que mudou
          permissao.tema.forEach((tema) => {
            changedItems.push({
              temaId: tema.temaId,
              municipioId: municipioId,
            });
          });
        }
      });

      return changedItems;
    },
    getDetailedChanges() {
      const changes = {
        added: [],
        removed: [],
        unchanged: [],
      };

      // Percorre todos os municípios das permissões atuais
      this.usuario.permissoes.forEach((permissao) => {
        const municipioId = permissao.municipioId;
        const temasAtuais = permissao.tema.map((t) => t.temaId);
        const temasOriginais = this.temasHabilitadosHash[municipioId]
          ? this.temasHabilitadosHash[municipioId].map((t) => t.temaId)
          : [];

        // Encontra temas adicionados
        const adicionados = temasAtuais.filter(
          (temaId) => !temasOriginais.includes(temaId)
        );
        adicionados.forEach((temaId) => {
          changes.added.push({
            temaId,
            municipioId,
            action: "add",
          });
        });

        // Encontra temas removidos
        const removidos = temasOriginais.filter(
          (temaId) => !temasAtuais.includes(temaId)
        );
        removidos.forEach((temaId) => {
          changes.removed.push({
            temaId,
            municipioId,
            action: "remove",
          });
        });

        // Temas que permaneceram
        const inalterados = temasAtuais.filter((temaId) =>
          temasOriginais.includes(temaId)
        );
        inalterados.forEach((temaId) => {
          changes.unchanged.push({
            temaId,
            municipioId,
            action: "unchanged",
          });
        });
      });

      return changes;
    },
    insertUser() {
      this.setLoading(true);

      // Pega apenas os municípios que tiveram mudanças
      const changedMunicipios = this.getChangedMunicipios();

      console.log("Apenas as mudanças:", changedMunicipios);

      // Se não houver mudanças, não faz nada
      if (changedMunicipios.length === 0) {
        this.setLoading(false);
        return;
      }
      // Se não houver mudanças, não faz nada
      if (changedMunicipios.length === 0) {
        this.setLoading(false);
        return;
      }

      // Envia apenas as mudanças para o backend
      municipioTemasHabilitadosAPI
        .salvarTemas(changedMunicipios)
        .then(({ data }) => {
          this.setLoading(false);
          this.$notification.success("Temas atualizados com sucesso");
          // Atualiza o estado original com as mudanças
          this.getMunicipioTemasHabilitados();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar temas");
        });
    },
    addPermission() {
      let multiplesMunicipios = [];
      let multiplesEixos = [];
      let multiplesMunicipiosEixos = [];

      var permissoesHash = this.usuario.permissoes.reduce((acc, curr) => {
        acc[curr.municipioId] = curr;
        return acc;
      }, {});

      if (
        this.permissao.municipio &&
        this.permissao.municipio.length &&
        this.permissao.tema &&
        this.permissao.tema.length
      ) {
        this.permissao.municipio.forEach((item) => {
          this.permissao.municipioId = item.municipioId;
          if (!permissoesHash[item.municipioId]) {
            permissoesHash[item.municipioId] = {
              ...this.permissao,
              municipio: item,
              tema: this.permissao.tema,
            };
          } else {
            var eixos = this.permissao.tema.filter((ei) =>
              permissoesHash[item.municipioId].tema.every(
                (tema) => ei.temaId != tema.temaId
              )
            );

            permissoesHash[item.municipioId].tema = [
              ...permissoesHash[item.municipioId].tema,
              ...eixos,
            ];
          }
        });

        Object.values(permissoesHash).forEach((item) => {
          multiplesMunicipiosEixos.push(item);
        });

        this.usuario.permissoes = multiplesMunicipiosEixos;
      } else if (this.permissao.municipio && this.permissao.municipio.length) {
        this.permissao.municipio.forEach((item) => {
          this.permissao.municipioId = item.municipioId;
          if (!permissoesHash[item.municipioId]) {
            permissoesHash[item.municipioId] = {
              ...this.permissao,
              municipioId: item.municipioId,
              municipio: item,
              tema: [],
            };
          }
        });

        Object.values(permissoesHash).forEach((item) => {
          multiplesMunicipios.push(item);
        });

        this.usuario.permissoes = multiplesMunicipios;
      } else if (this.permissao.tema && this.permissao.tema.length) {
        this.permissao.permissao = null;

        if (!permissoesHash[null]) {
          permissoesHash[null] = {
            ...this.permissao,
            municipioId: null,
            municipio: [],
            tema: this.permissao.tema,
          };
        } else {
          var eixos = this.permissao.tema.filter((ei) =>
            permissoesHash[null].tema.every((tema) => ei.temaId != tema.temaId)
          );

          permissoesHash[null] = {
            ...permissoesHash[null],
            tema: [...permissoesHash[null].tema, ...eixos],
          };
        }

        Object.values(permissoesHash).forEach((item) => {
          multiplesEixos.push(item);
        });

        this.usuario.permissoes = multiplesEixos;
      }

      this.usuario.permissoes = this.usuario.permissoes
        .map((item) => ({ ...item, nome: item.municipio.nome }))
        .sort(this.compare);

      this.permissao = {
        municipioId: null,
        municipio: [],
        permissaoId: null,
        permissao: null,
        eixoId: null,
        tema: [],
        selection: false,
      };
    },

    compare(a, b) {
      if (
        typeof a[this.field] === "string" &&
        typeof b[this.field] === "string"
      ) {
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return -1;
        }
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return 1;
        }
      } else {
        if (a[this.field] < b[this.field]) {
          return -1;
        }
        if (a[this.field] > b[this.field]) {
          return 1;
        }
      }
      return 0;
    },
    changePermission() {
      this.permissao.permissaoId = this.permissao.permissao.permissaoId;
    },
    getEixos() {
      axisAPI
        .list()
        .then((resp) => {
          this.listaEixos = resp.data;
        })
        .catch();
    },
    removePermission() {
      this.usuario.permissoes = this.notSelectionItems;
    },
    removeAllPermission() {
      this.usuario.permissoes = [];
    },
    removeOnePermission({ item }) {
      this.usuario.permissoes.forEach((val, index) => {
        if (item == val) {
          this.usuario.permissoes.splice(index, 1);
        }
      });
    },
    getMunicipioTemasHabilitados() {
      this.setLoading(true);

      municipioTemasHabilitadosAPI
        .list()
        .then((resp) => {
          this.setLoading(false);
          this.temasHabilitados = resp.data;

          this.temasHabilitadosHash = this.temasHabilitados.reduce(
            (acc, curr) => {
              if (!acc[curr.municipioId]) acc[curr.municipioId] = [];
              acc[curr.municipioId].push(curr);
              return acc;
            },
            {}
          );
        })
        .catch();
    },
  },

  computed: {
    ...mapGetters(["isFullAdmin", "isGov"]),
    selectionItems() {
      return this.usuario.permissoes.filter((item) => item.selection);
    },
    notSelectionItems() {
      return this.usuario.permissoes.filter((item) => !item.selection);
    },
  },
};
</script>
